import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const BUSINESS_IDS = '/v3/me'
const GET_BUSINESS_USER = '/v1/GetBusinessUser'
const CREATE_BUSINESS_USER = '/v1/CreateBusinessUser'
const UPDATE_BUSINESS_USER = '/v1/UpdateBusinessUser'
const UPDATE_INDIVIDUAL_USER = '/v1/UpdateIndividualUser'
// Change Mobile Number: is the new number free? (KMP CheckNewNumberExists)
const CHECK_NEW_NUMBER = '/v1/mobile/migrate'
const BUSINESS_MANAGER = 'v1/BusinessManagers'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = `${getEnvConfig('WEB_BASE_URL')}/identity` || ''

const api = new ApiService(endpoint, headers)
api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

const apiV2 = new ApiService(endpoint, headers)
apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const getBusinessIds = () => {
  return api.getRequest(BUSINESS_IDS, {})
}

export const getBusinessUser = async (businessId: any) => {
  return apiV2.postRequest(
    GET_BUSINESS_USER,
    { business_user_id: businessId },
    { 'OKC-Business-Id': businessId }
  )
}

export const createBusinessUser = async (name: string) => {
  return apiV2.postRequest(CREATE_BUSINESS_USER, { name })
}

export const updateBusinessUser = async (payload: any) => {
  return apiV2.postRequest(UPDATE_BUSINESS_USER, payload)
}

export interface IUpdateIndividualUserPayload {
  individual_user_id: string
  individual_user: {
    user: { id: string; mobile?: string }
    image_backup_destination?: string
    payment_password_enabled?: boolean
    four_digit_pin_in?: boolean
  }
  update_image_backup_destination?: boolean
  update_payment_password_enabled?: boolean
  update_four_digit_pin_opt_in?: boolean
  // Recovery mobile: the number itself travels inside the verified-OTP token
  update_alternate_mobile?: boolean
  alternate_mobile_otp_token?: string
  // Change Mobile Number: both numbers verified by OTP, tokens prove it (KMP updateBusinessMobile)
  update_mobile?: boolean
  current_mobile_otp_token?: string
  new_mobile_otp_token?: string
}

export const updateIndividualUser = async (payload: IUpdateIndividualUserPayload) => {
  return api.postRequest(UPDATE_INDIVIDUAL_USER, payload)
}

// Error codes the identity service answers with when the number already has an account
export const NUMBER_TAKEN_ERRORS = [
  'merchant_registered',
  'merchant_exists',
  'user_exists',
  'user_registered'
]

// 200 when the number can be migrated to; otherwise the error body names why
export const checkNewNumberExists = async (mobile: string) => {
  return apiV2.getRequest(CHECK_NEW_NUMBER, { mobile })
}

export const getBusinessManager = async (businessId: string) => {
  return apiV2.getRequest(BUSINESS_MANAGER, {}, { 'OKC-Business-Id': businessId })
}

export const updateBusinessManager = async (mobile: string) => {
  return apiV2.postRequest(BUSINESS_MANAGER, { mobile })
}

export const revokeBusinessManager = async (mobile: string) => {
  return apiV2.deleteRequest(BUSINESS_MANAGER, { mobile })
}

export const IdentityApi = {
  getBusinessIds,
  getBusinessUser,
  createBusinessUser,
  updateBusinessUser,
  updateIndividualUser,
  getBusinessManager,
  updateBusinessManager,
  revokeBusinessManager
}
